const CoverAuthorNameFontSize = {
  SMALL: '16px',
  MEDIUM: '24px',
  LARGE: '30px',
};

module.exports = CoverAuthorNameFontSize;
